import React, { useState } from 'react';
import styled from 'styled-components';
import { StyledProgramModalDiv } from 'npo/pages/ReportsBeta/ProgramModal/ProgramModalContent';
import TrueImpactModal from 'shared/design-system/components/TrueImpactModal';
import { Contribution, ContributionInvestment, Services } from '../api';
import { faClose } from '@fortawesome/pro-light-svg-icons';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import TrueImpactIconButton from 'shared/design-system/components/TrueImpactIconButton';
import TrueImpactTabs from 'shared/design-system/components/TrueImpactTabs';
import ContributionInvitation from './Tabs/ContributionInvitation';
import ContributionDetails, {
  ContributionDetailsProps,
} from './Tabs/ContributionDetails';
import ContributionAmounts from './Tabs/ContributionAmounts';
import ContributionDates from './Tabs/ContributionDates';
import ContributionLeftSideBar from './ContributionLeftSideBar';
import { NPOUser } from 'npo/pages/ReportsBeta/NewProgram/api';
import { RequestState } from 'shared/auth/hooks/useRequestState';

const tabs = [
  {
    value: 'details' as const,
    text: 'Details',
  },
  {
    value: 'amounts' as const,
    text: 'Amounts',
  },
  {
    value: 'dates' as const,
    text: 'Dates',
  },
  {
    value: 'invitation' as const,
    text: 'Invitation to Report',
  },
];

interface EditDonationModalProps {
  services: Services[];
  allPortfolios: RequestState<Contribution[]>;
  allNPOUsers: RequestState<{
    allUsers: NPOUser[];
  }>;
  open:
    | {
        contributionIndex: number;
        investmentIndex: number;
        contribution: Contribution;
        investment: ContributionInvestment;
      }
    | undefined;
  handleClose: () => unknown;
}

const StyledDiv = styled(StyledProgramModalDiv)`
  position: relative;
  .close-button {
    display: inline-block;
    cursor: pointer;
    position: absolute;
    top: ${SPACERS.medium};
    right: ${SPACERS.large};
    svg {
      fill: ${COLORS.blackBase};
    }
  }
  .tab-details {
    width: 100%;
    padding: ${SPACERS.extraLarge} ${SPACERS.medium};
  }
`;

type Tabs = 'details' | 'amounts' | 'dates' | 'invitation';
const EditDonationModal: React.FC<EditDonationModalProps> = ({
  open,
  services,
  allNPOUsers,
  allPortfolios,
  handleClose,
}) => {
  const [activeTab, setActiveTab] = useState<Tabs>('details');

  if (!open) return null;

  const props: ContributionDetailsProps = {
    services: services,
    allNPOUsers: allNPOUsers,
    allPortfolios: allPortfolios,
    contributionIndex: open.contributionIndex,
    investmentIndex: open.investmentIndex,
    contribution: open.contribution,
    investment: open.investment,
    className: 'tab-details',
  };

  return (
    <TrueImpactModal hideHeader={true} open={true} onClose={handleClose}>
      <StyledDiv>
        <TrueImpactIconButton
          icon={faClose}
          className="close-button"
          onClick={handleClose}
          label="Close"
        />
        <ContributionLeftSideBar
          contribution={open.contribution}
          investment={open.investment}
          investmentIndex={open.investmentIndex}
          className="left-modal-column"
        />
        <div className="right-modal-column">
          <TrueImpactTabs
            tabs={tabs}
            selectedValue={activeTab}
            handleChange={setActiveTab}
          />
          {activeTab === 'details' ? (
            <ContributionDetails {...props} />
          ) : activeTab === 'amounts' ? (
            <ContributionAmounts {...props} />
          ) : activeTab === 'dates' ? (
            <ContributionDates {...props} />
          ) : (
            <ContributionInvitation {...props} />
          )}
        </div>
      </StyledDiv>
    </TrueImpactModal>
  );
};

export default EditDonationModal;
